import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MappaAllertaComponent } from './mappa-allerta.component';



@NgModule({
  declarations: [MappaAllertaComponent],
  imports: [
    CommonModule,
  ],
  exports: [MappaAllertaComponent] 
})
export class MappaAllertaModule { }
